<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div>
    <gf-image-cropper v-if="currentCover" class="gf-cropper --cover"
    :selected-image-source="currentCover" input-name="cover" preview-border="1px" :aspect-ratio=17/5
    image-box-width="600" modal-window-width="800" @setDefault="setDefaultCover" />
  </div>
</template>

<script>
import UserService from '@shared/services/user.service';
import GfImageCropper from './GfImageCropper.vue';

export default {
  name: 'GfUserCoverCropper',
  components: { GfImageCropper },
  props: {
    currentCover: {
      type: String
    },
    isAdminVersion: {
      type: Boolean,
      default: false
    },
    userUuid: {
      type: String
    }
  },
  methods: {
    setDefaultCover() {
      const setUserCover = this.isAdminVersion
        ? UserService.setUserDefaultCoverAdmin(this.userUuid)
        : UserService.setDefaultCover();

      setUserCover.then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style lang="scss">
.gf-cropper.--cover {
  position: relative;
  .gf-cropper__preview-image {
    height: 200px;
    object-fit: cover;
    object-position: center;
  }
}
</style>
